/**
 * HESABIM — iki adimli dogrulama
 *
 * Operatorun parolasi calinirsa BUTUN musterilerin postasi tehlikeye girer.
 * Bu ekranin tek isi o riski kaldirmak, ve bunu kullaniciyi kendi panelinden
 * kilitlemeden yapmak: kurulum, DOGRU bir kod girilene kadar etkinlesmez.
 */
import { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";
import { api, oturum } from "../api";
import { Bildirim, Durum, Kart, Rozet, TekSeferlik, useCek } from "../ui";

function Kare({ uri }: { uri: string }) {
  const tuval = useRef<HTMLCanvasElement | null>(null);
  const [hata, setHata] = useState<string | null>(null);

  useEffect(() => {
    if (!tuval.current) return;
    QRCode.toCanvas(tuval.current, uri, { width: 220, margin: 1 }).catch((e: unknown) =>
      setHata(String(e)),
    );
  }, [uri]);

  if (hata) return <Bildirim tur="uyari">Kare kod çizilemedi; aşağıdaki anahtarı elle girin.</Bildirim>;
  return (
    <div style={{ background: "#fff", padding: 12, borderRadius: 8, display: "inline-block" }}>
      <canvas ref={tuval} />
    </div>
  );
}

export function Hesabim() {
  const k = oturum.kullanici();
  const durum = useCek(() => api.ikiAdimDurum(), []);
  const [kurulum, setKurulum] = useState<{ sir: string; uri: string } | null>(null);
  const [kod, setKod] = useState("");
  const [yedekler, setYedekler] = useState<string[] | null>(null);
  const [bekliyor, setBekliyor] = useState(false);
  const [hata, setHata] = useState<string | null>(null);
  const [mesaj, setMesaj] = useState<string | null>(null);
  const [kapatmaKodu, setKapatmaKodu] = useState("");

  async function calistir(f: () => Promise<void>) {
    setBekliyor(true);
    setHata(null);
    try {
      await f();
    } catch (e: any) {
      setHata(e?.message ?? "İşlem yapılamadı");
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Hesabım</h1>
          <p>
            {k?.eposta} · {k?.rol === "operator" ? "operatör" : "müşteri paneli"}
          </p>
        </div>
      </div>

      {hata && <Bildirim tur="kotu">{hata}</Bildirim>}
      {mesaj && <Bildirim tur="iyi">{mesaj}</Bildirim>}

      {yedekler && (
        <Kart baslik="Yedek kodlarınız">
          <Bildirim tur="uyari">
            Bu kodlar <strong>bir daha gösterilmeyecek</strong>. Telefonunuzu kaybederseniz panele
            girmenin tek yolu bunlardır; yazdırın ya da parola yöneticinize kaydedin. Her kod
            yalnızca bir kez kullanılır.
          </Bildirim>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
              gap: 8,
              marginTop: 12,
            }}
          >
            {yedekler.map((y) => (
              <code key={y} className="sir" style={{ textAlign: "center", padding: "8px 4px" }}>
                {y}
              </code>
            ))}
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
            <button
              className="dugme kucuk"
              onClick={() => navigator.clipboard?.writeText(yedekler.join("\n"))}
            >
              hepsini kopyala
            </button>
            <button className="dugme kucuk" onClick={() => setYedekler(null)}>
              kaydettim, kapat
            </button>
          </div>
        </Kart>
      )}

      <Durum cekim={durum}>
        {(y) => {
          const d = y.veri;
          if (d.etkin) {
            return (
              <>
                <Kart
                  baslik="İki adımlı doğrulama"
                  eylem={<Rozet tur="iyi">açık</Rozet>}
                >
                  <p>
                    Girişte parolanızın yanında doğrulama uygulamanızdaki 6 haneli kod isteniyor.
                    Parolanız ele geçse bile hesabınıza girilemez.
                  </p>
                  <dl className="ikili">
                    <dt>Kalan yedek kod</dt>
                    <dd>
                      {d.kalanYedekKod}
                      {d.kalanYedekKod <= 2 && (
                        <>
                          {" "}
                          <Rozet tur="uyari">azaldı</Rozet>
                        </>
                      )}
                    </dd>
                  </dl>
                  {d.kalanYedekKod <= 2 && (
                    <Bildirim tur="uyari">
                      Yedek kodlarınız azaldı. Aşağıdan yenileyin; eskiler geçersiz olur.
                    </Bildirim>
                  )}
                </Kart>

                <Kart baslik="İşlemler">
                  <label className="alan">
                    <span>Doğrulama kodu</span>
                    <input
                      value={kapatmaKodu}
                      onChange={(e) => setKapatmaKodu(e.target.value.replace(/[^0-9A-Za-z-]/g, ""))}
                      placeholder="123456"
                      inputMode="numeric"
                      autoComplete="one-time-code"
                      maxLength={11}
                    />
                    <small>
                      Aşağıdaki işlemler için uygulamanızdaki güncel kodu (ya da bir yedek kodu) yazın.
                      Bu, parolanızı ele geçiren birinin korumayı kapatmasını engeller.
                    </small>
                  </label>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <button
                      className="dugme"
                      disabled={!kapatmaKodu || bekliyor}
                      onClick={() =>
                        calistir(async () => {
                          const s = await api.ikiAdimYedekYenile(kapatmaKodu);
                          setYedekler(s.veri.yedekKodlar);
                          setKapatmaKodu("");
                          setMesaj(s.mesaj);
                          durum.yenile();
                        })
                      }
                    >
                      Yedek kodları yenile
                    </button>
                    <button
                      className="dugme tehlike"
                      disabled={!kapatmaKodu || bekliyor}
                      onClick={() => {
                        if (!confirm("İki adımlı doğrulama kapatılsın mı? Hesabınız yalnızca parolayla korunur.")) return;
                        calistir(async () => {
                          await api.ikiAdimKapat(kapatmaKodu);
                          setKapatmaKodu("");
                          setMesaj("İki adımlı doğrulama kapatıldı.");
                          durum.yenile();
                        });
                      }}
                    >
                      Kapat
                    </button>
                  </div>
                </Kart>
              </>
            );
          }

          if (kurulum) {
            return (
              <Kart baslik="İki adımlı doğrulamayı kurun">
                <ol className="adimlar">
                  <li>
                    Telefonunuzda bir doğrulama uygulaması açın (Google Authenticator, Microsoft
                    Authenticator, 1Password, Authy…).
                  </li>
                  <li>Aşağıdaki kare kodu okutun.</li>
                  <li>Uygulamanın gösterdiği 6 haneli kodu buraya yazın.</li>
                </ol>

                <div style={{ display: "flex", gap: 24, flexWrap: "wrap", alignItems: "flex-start" }}>
                  <Kare uri={kurulum.uri} />
                  <div style={{ flex: 1, minWidth: 240 }}>
                    <p>
                      <strong>Kare kodu okutamıyorsanız</strong> uygulamaya bu anahtarı elle girin:
                    </p>
                    <code className="sir" style={{ display: "block", wordBreak: "break-all" }}>
                      {kurulum.sir}
                    </code>
                    <button
                      className="dugme kucuk"
                      style={{ marginTop: 8 }}
                      onClick={() => navigator.clipboard?.writeText(kurulum.sir)}
                    >
                      anahtarı kopyala
                    </button>

                    <label className="alan" style={{ marginTop: 16 }}>
                      <span>Uygulamadaki 6 haneli kod</span>
                      <input
                        value={kod}
                        onChange={(e) => setKod(e.target.value.replace(/\D/g, "").slice(0, 6))}
                        placeholder="123456"
                        inputMode="numeric"
                        autoComplete="one-time-code"
                        autoFocus
                      />
                    </label>
                    <div style={{ display: "flex", gap: 8 }}>
                      <button
                        className="dugme"
                        onClick={() => {
                          setKurulum(null);
                          setKod("");
                        }}
                      >
                        Vazgeç
                      </button>
                      <button
                        className="dugme ana"
                        disabled={kod.length !== 6 || bekliyor}
                        onClick={() =>
                          calistir(async () => {
                            const s = await api.ikiAdimOnayla(kod);
                            setYedekler(s.veri.yedekKodlar);
                            setKurulum(null);
                            setKod("");
                            setMesaj(s.mesaj);
                            durum.yenile();
                          })
                        }
                      >
                        {bekliyor ? "Doğrulanıyor…" : "Doğrula ve aç"}
                      </button>
                    </div>
                  </div>
                </div>

                <Bildirim>
                  Kod kabul edilmezse telefonunuzun saatinin doğru olduğundan emin olun. Doğrulama
                  kodları saate göre üretilir; birkaç dakikalık sapma bile kodu geçersiz kılar.
                </Bildirim>
              </Kart>
            );
          }

          return (
            <Kart baslik="İki adımlı doğrulama" eylem={<Rozet tur="uyari">kapalı</Rozet>}>
              <p>
                Şu anda hesabınız yalnızca parolayla korunuyor.{" "}
                {k?.rol === "operator" && (
                  <strong>
                    Operatör parolası ele geçirilirse bütün müşterilerin postası tehlikeye girer.
                  </strong>
                )}{" "}
                İki adımlı doğrulama, parolanızı bilen birinin telefonunuz olmadan giriş yapmasını
                engeller.
              </p>
              <Bildirim>
                Kurulum, doğru bir kod girene kadar <strong>etkinleşmez</strong>. Uygulamaya
                ekleyemezseniz hiçbir şey değişmez; kendinizi panelden kilitleme riskiniz yok.
              </Bildirim>
              <button
                className="dugme ana"
                disabled={bekliyor}
                style={{ marginTop: 12 }}
                onClick={() =>
                  calistir(async () => {
                    const s = await api.ikiAdimBaslat();
                    setKurulum(s.veri);
                  })
                }
              >
                {bekliyor ? "Hazırlanıyor…" : "İki adımlı doğrulamayı aç"}
              </button>
            </Kart>
          );
        }}
      </Durum>
    </>
  );
}
